module.exports = __webpack_public_path__ + "media/images/featuredon_boldbusiness-adeeb32b.png";